import { render, staticRenderFns } from "./ReRegisterThanks.vue?vue&type=template&id=208bbbcc&"
import script from "./ReRegisterThanks.vue?vue&type=script&lang=js&"
export * from "./ReRegisterThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports